import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { getAvailability } from '../address/actions';
import _ from 'lodash';
import moment from 'moment';
import Marker from 'images/icons/controls/map-marker.svg?react-svg';
import {
  fontSizeS,
  sansSerifLight,
  mutedBgAccent,
  danger,
  accent
} from 'scy/text/styles.mod.scss';
import { flex, flex1, centerItems } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import { clickable, linkText } from 'scy/utils.mod.scss';

class DeliveryAvailability extends React.Component {
  componentDidMount() {
    if (!this.props.availability) {
      this.props.getAvailability();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.address, this.props.address)) {
      this.props.getAvailability();
    }
  }

  render() {
    const { shipping, product, address, availability, vendor } = this.props;

    if (!address || !address.lat || !address.lng) {
      return <NoAddress onClick={() => this.props.showAvailability()} />;
    }

    if (!product.price) {
      return <CurrentlyUnavailable product={product} />;
    }

    if (shipping && product.special_order) {
      return <SpecialOrder />;
    }

    if (shipping) {
      return <ShippingAvailable />;
    }

    if (availability && availability.immediate_delivery) {
      return <ImmediateDelivery />;
    }

    const inServiceArea = shipping || (vendor && vendor.inside_delivery_zone);
    if (!inServiceArea) {
      return <NotInServiceArea onClick={() => this.props.showAvailability()} />;
    }

    return <NextAvailableDelivery vendor={vendor} />;
  }
}

function Container({ showDanger, onClick, children }) {
  return (
    <div
      onClick={onClick}
      className={classnames(flex, centerItems, margin.bottom_xs, accent, {
        [clickable]: !!onClick
      })}
    >
      <Marker />
      <p
        className={classnames(sansSerifLight, fontSizeS, margin.xs, flex1, {
          [danger]: showDanger,
          [mutedBgAccent]: !showDanger
        })}
      >
        {children}
      </p>
    </div>
  );
}

function NoAddress({ onClick }) {
  return (
    <Container onClick={onClick}>
      Set delivery address to see local pricing
    </Container>
  );
}

function SpecialOrder() {
  return (
    <Container>This product may take 2-3 business days to process.</Container>
  );
}

function ShippingAvailable() {
  return <Container>2-day shipping available</Container>;
}

function ImmediateDelivery() {
  return <Container>Get this delivered in 30 minutes</Container>;
}

function CurrentlyUnavailable({ product }) {
  const category = product.category || {};
  const categoryURL = category.url;
  const categoryName = category.name;
  const hasCategory = !!categoryURL && !!categoryName;

  return (
    <Container showDanger>
      This product is currently unavailable in your area.{' '}
      {hasCategory && 'Shop more '}
      {hasCategory && (
        <a href={'/' + categoryURL} className={linkText}>
          {categoryName}
        </a>
      )}
    </Container>
  );
}

function NotInServiceArea({ onClick }) {
  return (
    <Container onClick={onClick}>
      Delivery isn’t available at your current address, please enter a new
      delivery address
    </Container>
  );
}

function NextAvailableDelivery({ vendor }) {
  if (!vendor) return null;

  const hours = vendor.hours || {};
  const nextDate = hours.open;
  const calendar =
    nextDate &&
    moment(nextDate * 1000).calendar(null, {
      sameDay: '[today at] h:mm A',
      nextDay: '[tomorrow at] h:mm A'
    });

  if (!calendar) return null;

  return <Container>Next available delivery {calendar}</Container>;
}

const ConnectedDeliveryAvailability = connect(
  state => ({
    address: state.address,
    shipping: state.address.shipping,
    availability: state.address.availability,
    vendor: state.address.vendor
  }),
  { getAvailability }
)(DeliveryAvailability);

export default ConnectedDeliveryAvailability;
